import { gql, useSubscription } from '@apollo/client';
import { useContext, useEffect } from 'react';
import { CompanyContext } from '../../context/CompanyContext';
import React from 'react';
import { forNotification } from '../Common/forNotification';
import { ProductMasterDataFragments } from '../../graphql/productMasterData.graphql';
import { ProductMasterData } from '../../types/product_master_data/productMasterData';
import { useDispatch } from 'react-redux';
import { productMasterDataSlice } from '../../providers/ProductMasterDataProvider';

const productMasterDataSubscription = gql`
  subscription productMasterDataNotification($companyId: String!) {
    productMasterDataNotification(companyId: $companyId) {
      companyId
      entities {
        ...ProductMasterData
      }
      topic
      date
    }
  }
  ${ProductMasterDataFragments.productMasterData}
`;

export class ProductMasterDataNotificationResponse extends forNotification<ProductMasterData>(
  'productMasterDataNotification',
) {}

export default function ProductMasterDataNotification({}) {
  const { currentCompany } = useContext(CompanyContext);
  const dispatch = useDispatch();

  if (!currentCompany) return null;

  const { data: productMasterDataNotification } = useSubscription<ProductMasterDataNotificationResponse>(
    productMasterDataSubscription,
    {
      variables: { companyId: currentCompany.id },
    },
  );

  const handleProductMasterDataNotification = (notification?: ProductMasterDataNotificationResponse) => {
    if (!notification?.productMasterDataNotification) return;
    const productMasterDataNotification = notification.productMasterDataNotification;

    switch (productMasterDataNotification.topic) {
      case 'CREATE':
      case 'UPDATE':
        dispatch(productMasterDataSlice.actions.add(productMasterDataNotification.entities));
        break;
      case 'DELETE':
        dispatch(productMasterDataSlice.actions.delete(productMasterDataNotification.entities));
    }
  };

  useEffect(() => {
    handleProductMasterDataNotification(productMasterDataNotification);
  }, [productMasterDataNotification]);

  return <></>;
}
